import axios from 'axios';

import { rutas } from '../../../routes_backend/routes.jsx';

export const VENTAS_POR_CLIENTES_REQUEST = 'VENTAS_POR_CLIENTES_REQUEST';
export const VENTAS_POR_CLIENTES_RESPONSE = 'VENTAS_POR_CLIENTES_RESPONSE';
export const VENTAS_POR_CLIENTES_FAILURE = 'VENTAS_POR_CLIENTES_FAILURE';

export function get_ventas_por_cliente(from, to) {
	let url = `${rutas.get_ventas_por_cliente}?from=${from}&to=${to}`;
	return (dispatch) => {
		dispatch({
			type: VENTAS_POR_CLIENTES_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				dispatch({
					type: VENTAS_POR_CLIENTES_RESPONSE,
					ventascliente: res
				});
			})
			.catch((error) => {
				dispatch({
					type: VENTAS_POR_CLIENTES_FAILURE,
					error: error
				});
			});
	};
}

export const EXISTENCIA_COMERCIAL_REQUEST = 'EXISTENCIA_COMERCIAL_REQUEST';
export const EXISTENCIA_COMERCIAL_RESPONSE = 'EXISTENCIA_COMERCIAL_RESPONSE';
export const EXISTENCIA_COMERCIAL_FAILURE = 'EXISTENCIA_COMERCIAL_FAILURE';

export function get_existencia_comercial() {
	let url = `${rutas.get_existencia_comercial}`;
	return (dispatch) => {
		dispatch({
			type: EXISTENCIA_COMERCIAL_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				dispatch({
					type: EXISTENCIA_COMERCIAL_RESPONSE,
					existencia_comercial: res
				});
			})
			.catch((error) => {
				dispatch({
					type: EXISTENCIA_COMERCIAL_FAILURE,
					error: error
				});
			});
	};
}

export const VENTAS_POR_DEPARTAMENTO_REQUEST = 'VENTAS_POR_DEPARTAMENTO_REQUEST';
export const VENTAS_POR_DEPARTAMENTO_RESPONSE = 'VENTAS_POR_DEPARTAMENTO_RESPONSE';
export const VENTAS_POR_DEPARTAMENTO_FAILURE = 'VENTAS_POR_DEPARTAMENTO_FAILURE';

export function get_venta_por_departamento(from, to, planta) {
	let url = `${rutas.get_ventas_por_departamento}?from=${from}&to=${to}&planta=${planta}`;
	return (dispatch) => {
		dispatch({
			type: VENTAS_POR_DEPARTAMENTO_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				dispatch({
					type: VENTAS_POR_DEPARTAMENTO_RESPONSE,
					venta_departamento: res
				});
			})
			.catch((error) => {
				dispatch({
					type: VENTAS_POR_DEPARTAMENTO_FAILURE,
					error: error
				});
			});
	};
}

export const VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_REQUEST = 'VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_REQUEST';
export const VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_RESPONSE = 'VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_RESPONSE';
export const VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_FAILURE = 'VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_FAILURE';

export function get_venta_por_departamento_en_unidades(from, to, planta) {
	let url = `${rutas.get_ventas_por_departamento_en_unidades}?from=${from}&to=${to}&planta=${planta}`;
	return (dispatch) => {
		dispatch({
			type: VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				// console.log(res);

				dispatch({
					type: VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_RESPONSE,
					venta_departamento_unidades: res
				});
			})
			.catch((error) => {
				dispatch({
					type: VENTAS_POR_DEPARTAMENTO_EN_UNIDADES_FAILURE,
					error: error
				});
			});
	};
}

export const VENTAS_POR_DEPARTAMENTO_DETALLADO_REQUEST = 'VENTAS_POR_DEPARTAMENTO_DETALLADO_REQUEST';
export const VENTAS_POR_DEPARTAMENTO_DETALLADO_RESPONSE = 'VENTAS_POR_DEPARTAMENTO_DETALLADO_RESPONSE';
export const VENTAS_POR_DEPARTAMENTO_DETALLADO_FAILURE = 'VENTAS_POR_DEPARTAMENTO_DETALLADO_FAILURE';

export function get_venta_por_departamento_detalle(from, to, planta) {
	let url = `${rutas.get_ventas_por_departamento_detalle}?from=${from}&to=${to}&planta=${planta}`;
	return (dispatch) => {
		dispatch({
			type: VENTAS_POR_DEPARTAMENTO_DETALLADO_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				// console.log(res);
				dispatch({
					type: VENTAS_POR_DEPARTAMENTO_DETALLADO_RESPONSE,
					venta_departamento_detalle: res
				});
			})
			.catch((error) => {
				dispatch({
					type: VENTAS_POR_DEPARTAMENTO_DETALLADO_FAILURE,
					error: error
				});
			});
	};
}

export const VENTAS_POR_REGION_REQUEST = 'VENTAS_POR_REGION_REQUEST';
export const VENTAS_POR_REGION_RESPONSE = 'VENTAS_POR_REGION_RESPONSE';
export const VENTAS_POR_REGION_FAILURE = 'VENTAS_POR_REGION_FAILURE';

export function get_venta_por_region(usuario, mes, year) {
	let url = `${rutas.get_ventas_por_region}?usuario=${usuario}&mes=${mes}&year=${year}`;
	return (dispatch) => {
		dispatch({
			type: VENTAS_POR_REGION_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				dispatch({
					type: VENTAS_POR_REGION_RESPONSE,
					venta_region: res
				});
			})
			.catch((error) => {
				dispatch({
					type: VENTAS_POR_REGION_FAILURE,
					error: error
				});
			});
	};
}
